import type { SectionKey, SectionState } from "./dto";

// ONE truth for "may the client work inside this step now". Both the SPA gate
// (rail click, workspace render, padlock marker) and the server resource
// release read it, so a deep link cannot walk past the padlock the rail shows.
//
// `locked` is the obvious padlock. Know-how in `working` is the TEAM's window:
// S27 starts the Drive sharing from the q1 answer (the account question lives
// in q1, so this fires BEFORE the questionnaire is submitted) and S06 opens the
// step only once the folder and the source doc exist. The step contract says
// "Otevre se po odeslani dotazniku k Buddymu", so the know-how workspace and
// its resources stay closed until the step is really the client's.
export function clientSectionOpen(section: SectionKey, state: SectionState): boolean {
  if (state === "locked") return false;
  if (section === "knowhow") return state === "next" || state === "done";
  return true;
}
